import { UseCase } from "../../useCase"
import { Survey } from "../../../entities/Survey"
import { SurveyRepository } from "../../../repositories/surveyRepository"
import { CreateSurveyRequest } from "./request"
import { CreateSurveyResponse } from "./response"

export class CreateSurveyUseCase implements UseCase<CreateSurveyRequest, CreateSurveyResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec(survey: Survey) {
		return this._repository.createSurvey(survey)
	}
}
